import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { HelpService } from '../../services/help/help.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { CalendarService } from '../../services/calendar/calendar.service';
import { UserService } from '../../services/user/user.service';
import { AddonService } from '../../services/addon/addon.service';
import _ from 'lodash';

@Component({
	selector: 'pcm-data-page-po',
	templateUrl: './data-page-po.component.html',
	styleUrls: ['./data-page-po.component.scss']
})
export class DataPagePOComponent implements OnInit, OnDestroy {

	@ViewChild('contractorDetails') contractorDetails;
	@ViewChild('poTabs') poTabs;
	@ViewChild('invoiceModal') invoiceModal;
	@ViewChild('poContractorModal') poContractorModal;
	@ViewChild('headerActions') headerActions;

	dataObj = this.configService.purchaseOrderDataObj;
	dataConfig;
	poLineConfig;

	title = 'Purchase Order';
	contractorTitle = 'Full Record';
	contractorEditTitle = 'My Edits';
	contractorApprovalTitle = 'My Approvals';

	contractorTableTitle = 'Contractor Records';
	invoiceTableTitle = 'Invoice Records';
	invoiceTableColumns = [];

	poNumber;
	supplierId;

	initialPoContractors = [];
	awaitingContractors = false;
	awaitingContractor = false;
	showPOCOntractorModal = false;
	showMultiCalendarModal = false;
	mergeEdits;

	lineItemContractors = [];

	extraContractor;
	mergeModalTitle = 'Merge Contractor Record';
	mergeModalHelp = 'Select a contractor record from the table below to merge with the previously selected contractor record.';

	invoiceUpdateListener;
	contractorsUpdateListener;
	pendingContractorsUpdateListener;
	contractorUpdateListener;
	contractorAddonsUpdateListener;
	jrSteps = [];
	jrStepIDs = [];

	acceptedCalError = false;
	calendarAccessError = 'You do not have access to the invoice calendar that is assigned to this PO. Please contact your Supplier Administrator';

	useFormState = true;

	allowReject = false;	// only support to reject contractor warranty
	showConfirmation = false;
	confirmationMessage = 'Are you sure you want to perform the action?';
	confirmationAction = 'APPROVE';	// APPROVE or REJECT

	hasSuccessfullyAddedContractor = false;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public configService: ConfigService,
		public purchaseOrderService: PurchaseOrderService,
		public contractorService: ContractorService,
		public dataService: DataService,
		private displayService: DisplayService,
		public helpService: HelpService,
		public invoiceService: InvoiceService,
		public calendarService: CalendarService,
		public userService: UserService,
		private addonService: AddonService
	) {
		this.helpService.PO.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});
	}

	ngOnInit() {
		this.contractorService.resetEditing();
		this.addonService.loadContractorAddons();
		this.dataConfig = this.configService.getDataObj(this.dataObj);
		this.poLineConfig = this.configService.getDataObj('poline');
		this.purchaseOrderService.dataConfig = this.configService.getDataObj(this.purchaseOrderService.dataObj);
		this.contractorService.dataConfig = this.configService.getDataObj(this.contractorService.dataObj);
		this.contractorService.shortTableConfig = this.configService.getTableFields(this.configService.contractorDataObj, true);
		this.invoiceService.dataConfig = this.configService.getDataObj(this.invoiceService.dataObj);

		this.invoiceTableColumns = this.configService.getTableFields(this.invoiceService.dataObj, true);

		this.purchaseOrderService.selectDefaultTab(this.purchaseOrderService.tabsData.tabs);

		this.displayService.clearLoading();
		this.dataService.clearPOContractor();

		this.route.params.subscribe(params => {
			this.poNumber = params['poNumber'];
			// need get the list of invoice calenders for the PO
			this.dataService.updateInvoiceCalendars([]);
			const data = {ponumber: this.poNumber};
			this.calendarService.loadCalendars(this.calendarService.tabsData.listTabs, data);
			this.supplierId = params['supplierId'];
			// need reset poContractorSelections and filteredPOContractorSelections
			this.dataService.updatePOContractorSelections([]);
			this.dataService.updatePOPendingContractors([]);
			this.contractorService.selectDefaultTab(this.contractorService.tabsData.migrateListTabs);
			this.purchaseOrderService.loadPO(this.poNumber, this.supplierId, true);
			this.contractorService.activePO = params['poNumber'];
			this.invoiceService.activePO = params['poNumber'];
			this.invoiceService.selectDefaultTab(this.invoiceService.tabsData.poListTabs);

			// need to load all PO contractors to determine if line item can hold more contractors
			this.contractorService.loadPOContractors(this.poNumber, this.contractorService.getPOAllTab(), true);
		});

		this.invoiceUpdateListener = this.dataService.invoiceUpdateListener().subscribe((event) => {
			this.invoiceService.selectDefaultTab(this.invoiceService.tabsData.poListTabs);
		});

		this.contractorsUpdateListener = this.dataService.poContractorsUpdateListener().subscribe((event) => {
			this.checkPOContractors();
		});

		this.pendingContractorsUpdateListener = this.dataService.poPendingContractorsUpdateListener().subscribe((event) => {
			this.checkPOPendingContractors();
		});

		this.contractorUpdateListener = this.dataService.poContractorUpdateListener().subscribe((event) => {
			this.mergeContractorEdits();
			this.allowReject = false;
			if (this.dataService.poContractorDetails['warranty'] && this.userService.persona === this.configService.personaProps.sam) {
				this.allowReject = true;
			}
		});

		this.contractorAddonsUpdateListener = this.dataService.contractorAddonsUpdateListener().subscribe((event) => {
			console.log('PO PAGE ADDONS UPDATED', this.dataService.contractorAddons);
			this.contractorService.dataConfig = this.configService.getDataObj(this.contractorService.dataObj, this.dataService.contractorAddons);
		});

		console.log('DATA PAGE PO CONFIG: ', this.dataConfig, this.dataService.poContractorDetails);
	}

	ngOnDestroy() {
		console.log('DESTROY DATA PAGE PO');
		this.invoiceUpdateListener.unsubscribe();
		this.contractorsUpdateListener.unsubscribe();
		this.contractorAddonsUpdateListener.unsubscribe();
	}

	checkPOInvoiceCalendar() {
		let multiplePOContractors = false;
		if (this.dataService.poContractors !== undefined) {
			if (this.dataService.poContractors.length > 1) {
				multiplePOContractors = true;
			}
		}
		if (!multiplePOContractors) {
			console.log('SINGLE PO CONTRACTOR');
			this.updatePOInvoiceCalendar();
		} else {
			console.log('MULTIPLE PO CONTRACTORS');
			this.showMultiCalendarModal = true;
		}
	}

	updatePOInvoiceCalendar() {
		console.log('ACCEPTABLE UPDATE PO INVOICE CALENDAR');
		this.showMultiCalendarModal = false;
		this.purchaseOrderService.updatePOInvoiceCalendar(this);
	}

	cancelCalendarModal() {
		this.dataService.poDetails[this.configService.calendarIdProp] = this.dataService.originalPODetails[this.configService.calendarIdProp];
		this.showMultiCalendarModal = false;
	}

	pageFormSubmit(event) {
		console.log('PAGE FORM SUBMIT', event, this.dataService.poContractorDetails);
		this.dataService.poContractorDetails = event.data;

		const contractorId = this.dataService.poContractorDetails[this.configService.contractorIdProp];
		this.contractorService.updateEditing(contractorId);

		if (this.dataService.poDetails[this.configService.calendarIdProp] !== this.dataService.originalPODetails[this.configService.calendarIdProp]) {
			console.log('INVOICE CALENDAR CHANGED', this.dataService.poDetails[this.configService.calendarIdProp], this.dataService.originalPODetails[this.configService.calendarIdProp]);
			this.checkPOInvoiceCalendar();
		} else {
			console.log('INVOICE CALENDAR UNCHANGED');
		}
		if (!_.isEqual(event.data, event.originalData)) {
			console.log('PAGE FORM DATA CHANGED', event.data, event.originalData);
			this.contractorService.submitContractor(this, event.data, event.originalData);
		} else {
			console.log('PAGE FORM DATA UNCHANGED');
		}
	}

	pageNewFormSubmit(event) {
		this.dataService.newContractorDetails = event.data;
		console.log('PAGE NEW FORM SUBMIT', event, this.dataService.newContractorDetails);

		// Check to see if any new contractors have been created before submitting new contractor
		// Event listener on loading po contractors will call checkPOContractors()
		this.awaitingContractors = true;
		this.initialPoContractors = _.cloneDeep(this.dataService.poContractors);
		this.contractorService.loadPOContractors(this.poNumber, this.contractorService.getPOAllTab(), true);
	}

	processNewContractor() {
		if (this.dataService.poDetails[this.configService.calendarIdProp] !== this.dataService.originalPODetails[this.configService.calendarIdProp]) {
			this.updatePOInvoiceCalendar();
		}
		this.contractorService.submitNewContractor(this);
	}

	mergeContractorEdits() {
		console.log('MERGE CONTRACTOR EDITS', this.mergeEdits, this.dataService.poContractorDetails, this.awaitingContractor);
		if (this.awaitingContractor) {
			const self = this;
			this.contractorService.dataConfig['fields'].forEach(function (d, i) {
				if (d.edit) {
					self.dataService.poContractorDetails[d.prop] = self.mergeEdits[d.prop];
				}
			});
			this.contractorService.selectActiveTab(this.contractorService.tabsData.tabs, 'myedits');
			this.awaitingContractor = false;
		}
	}

	confirmEdit(event) {
		console.log('CONFIRM EDIT', event);
		const self = this;
		const delay = setTimeout(function () {
			self.showPOCOntractorModal = false;
			self.awaitingContractor = true;
			self.mergeEdits = event.data;
			self.poContractorsTableClick(event.tableEvent);
			// self.mergeContractorEdits();
		}, 500);
	}

	confirmNew(event) {
		console.log('CONFIRM NEW', event);
		const self = this;
		const delay = setTimeout(function () {
			self.showPOCOntractorModal = false;
			self.pageNewFormSubmit(event);
		}, 500);
	}

	checkPOContractors() {

		console.log('CHECK PO CONTRACTORS', this.initialPoContractors, this.dataService.poContractors, this.awaitingContractors, this.contractorService.makingEdits);

		if (this.awaitingContractors) {

			const newContractor = this.dataService.newContractorDetails;
			const initialLineItemConts = [];
			const newLineItemConts = [];

			const self = this;
			this.initialPoContractors.forEach(function (d, i) {
				if (newContractor[self.configService.contractorLineItemProp] === d[self.configService.contractorLineItemProp]) {
					initialLineItemConts.push(d[self.configService.uuidProp]);
				}
			});

			this.dataService.poContractors.forEach(function (d, i) {
				if (newContractor[self.configService.contractorLineItemProp] === d[self.configService.contractorLineItemProp]) {
					newLineItemConts.push(d[self.configService.uuidProp]);
				}
			});

			// const sameContractors = this.dataService.isEqual(this.initialPoContractors, this.dataService.poContractors);

			const sameContractors = this.dataService.isEqual(initialLineItemConts, newLineItemConts);

			console.log('SAME CONTRACTORS', initialLineItemConts, newLineItemConts, sameContractors);

			if (!sameContractors) {
				console.log('PO CONTRACTORS HAS CHANGED');
				this.showPOCOntractorModal = true;

			} else {
				this.processNewContractor();
			}
			this.awaitingContractors = false;
		}
	}

	checkPOPendingContractors() {
		if (this.contractorService.makingEdits) {
			const pendingPOContractorsTab = this.contractorService.getPOPendingTab();
			const dataRef = this.contractorService.dataObj + '-' + pendingPOContractorsTab.prop + '-' + pendingPOContractorsTab.type;
			console.log('EDITING CONTRACTOR', this.contractorService.editingId, this.dataService.pageData[dataRef], this.dataService.poPendingContractors);
			const self = this;
			// this.dataService.pageData[dataRef][0].forEach(function(d,i){
			this.dataService.poPendingContractors.forEach(function (d, i) {
				if (d[self.configService.contractorIdProp] === self.contractorService.editingId) {
					const event = {
						row: d
					};
					self.contractorService.resetEditing();
					self.poContractorsTableClick(event);
				}
			});
		}
	}

	pageContentApprove() {
		// need confirmation if approval includes warranty (allowReject===true)
		if (this.allowReject) {
			this.confirmationMessage = this.contractorService.approveWarrantyConfirmation;
			this.confirmationAction = 'APPROVE';
			this.showConfirmation = true;
		} else {
			this.approveContractor();
		}
	}

	approveContractor(approvalstatus = '') {
		const poNumber = this.poNumber;
		const contractorId = this.dataService.poContractorDetails[this.configService.contractorIdProp];
		const supplierId = this.dataService.poContractorDetails[this.configService.supplierIdProp];
		if (approvalstatus === '') {
			approvalstatus = this.contractorService.approvalValues.approved;
		}
		this.contractorService.updateEditing(contractorId);
		this.contractorService.approveContractor(poNumber, contractorId, supplierId, approvalstatus, this);
	}

	pageContentReject() {
		this.confirmationMessage = this.contractorService.rejectWarrantyConfirmation;
		this.confirmationAction = 'REJECT';
		this.showConfirmation = true;
	}

	performAction() {
		if (this.confirmationAction === 'REJECT') {
			this.approveContractor('rejected');
		} else {
			this.approveContractor();
		}
		this.cancelConfirmation();
	}

	calendarUpdateSuccess() {
		console.log('PO CALENDAR UPDATE SUCCESS CALL', this.poNumber, this.supplierId);
		this.purchaseOrderService.loadPO(this.poNumber, this.supplierId, false);
	}

	contractorSuccess() {
		console.log('CONTRACTOR SUCCESS CALL', this.poNumber);
		this.hasSuccessfullyAddedContractor = true;
		this.contractorService.selectDefaultTab(this.contractorService.tabsData.poListTabs);
		this.contractorService.loadPOContractors(this.poNumber, this.contractorService.getPOPendingTab(), true);
		const delay = setTimeout(function () {
			if (this.contractorDetails?.uiTabs) {
				this.contractorDetails.uiTabs.checkTabs(this.contractorService.tabsData.tabs);
			}
		}, 1000);
	}

	poContractorsTableClick(event) {
		console.log('PO CONT TABLE CLICK: ', event);
		this.purchaseOrderService.poContractorsTableClick(event);
	}

	isReplacedPO() {
		const isReplacedPO = this.dataService.replacementPODetails ? true : false;
		return isReplacedPO;
	}

	poInvoiceTableClick(event) {
		this.invoiceService.tableClick(event);
	}

	pageAddItem(event) {
		console.log('PAGE ADD ITEM', this.contractorService.dataConfig);
		this.contractorService.resetEditing();
		this.purchaseOrderService.addPOContractor(event.data);
		const data = event.data;
		const prop = this.configService.uuidProp;
		this.purchaseOrderService.populateNewContractor(data, prop, this.contractorService.dataConfig);
		this.dataService.clearSelectedTableRows();
	}

	getMergeContractor() {
		this.extraContractor = _.cloneDeep(this.dataService.selectedTableRows[0]);
		return this.extraContractor;
	}

	mergeContractor() {
		this.purchaseOrderService.showMergeModal = true;
	}

	allowMerge() {
		let allowMerge = false;
		if (this.dataService.selectedTableRows[0] !== undefined) {
			allowMerge = true;
		}
		return allowMerge;
	}

	mergeSubmit(event) {
		console.log('MERGE SUBMIT', event);

		// this.dataService.poContractorDetails = event.data;
		// this.contractorService.submitContractor(this);

		const extraContractor = {};
		extraContractor[this.configService.uuidProp] = event.remove;
		extraContractor[this.configService.poNumberProp] = this.poNumber;

		console.log('EXTRA CONTRACTOR TO REMOVE', extraContractor);

		this.purchaseOrderService.mergeContractor(extraContractor, event.data, this);
		this.purchaseOrderService.showMergeModal = false;
	}

	mergeCancel(event) {
		console.log('MERGE CANCEL', event);
		this.purchaseOrderService.showMergeModal = false;
	}

	calErrorCancel(event) {
		this.acceptedCalError = true;
	}

	cancelConfirmation() {
		this.showConfirmation = false;
	}
}
